import { _ } from "i18n";
import { BooleanChoices } from "features/discover/types";
import { DatagridBackendFilterType, DatagridFilterInputType, type FilterConfig } from "../../types";
import { DiscoverGamesFilterField } from "../constants";

export const statusFilters = {
	hasVideo(): FilterConfig {
		return {
			id: DiscoverGamesFilterField.HasVideo,
			label: _("discover.gamesTable.filter.hasVideo"),
			type: DatagridFilterInputType.Boolean,
			field: DiscoverGamesFilterField.HasVideo,
			filterType: DatagridBackendFilterType.Boolean,
			options: BooleanChoices,
		};
	},
	gameStatus(): FilterConfig {
		return {
			id: DiscoverGamesFilterField.GameStatus,
			label: _("discover.gamesTable.filter.gameStatus"),
			type: DatagridFilterInputType.Multiselect,
			field: DiscoverGamesFilterField.GameStatus,
			filterType: DatagridBackendFilterType.Inarray,
			options: [],
			placeholder: _("discover.gamesTable.filterPlaceholder.gameStatus"),
		};
	},
	visibilityFlags(): FilterConfig[] {
		return [
			{
				id: DiscoverGamesFilterField.IsVip,
				label: _("discover.gamesTable.filter.isVip"),
				type: DatagridFilterInputType.Boolean,
				field: DiscoverGamesFilterField.IsVip,
				filterType: DatagridBackendFilterType.Boolean,
				options: BooleanChoices,
			},
			{
				id: DiscoverGamesFilterField.IsHidden,
				label: _("discover.gamesTable.filter.isHidden"),
				type: DatagridFilterInputType.Boolean,
				field: DiscoverGamesFilterField.IsHidden,
				filterType: DatagridBackendFilterType.Boolean,
				options: BooleanChoices,
			},
			{
				id: DiscoverGamesFilterField.IsHiddenForScout,
				label: _("discover.gamesTable.filter.isHiddenForScout"),
				type: DatagridFilterInputType.Boolean,
				field: DiscoverGamesFilterField.IsHiddenForScout,
				filterType: DatagridBackendFilterType.Boolean,
				options: BooleanChoices,
			},
		];
	},
	discoverAndProcessing(): FilterConfig[] {
		const isDiscoverFilterOptions = [
			{ label: _("discover.gamesTable.isDiscoverFilter.discover"), value: "true" },
			{ label: _("discover.gamesTable.isDiscoverFilter.elite"), value: "false" },
		];
		return [
			{
				id: DiscoverGamesFilterField.IsDiscover,
				label: _("discover.gamesTable.filter.isDiscover"),
				type: DatagridFilterInputType.Boolean,
				field: DiscoverGamesFilterField.IsDiscover,
				filterType: DatagridBackendFilterType.Boolean,
				options: isDiscoverFilterOptions,
			},
			{
				id: DiscoverGamesFilterField.RequestedProcessingLevel,
				label: _("discover.gamesTable.filter.requestedProcessingLevel"),
				type: DatagridFilterInputType.Select,
				field: DiscoverGamesFilterField.RequestedProcessingLevel,
				filterType: DatagridBackendFilterType.Exact,
				options: [
					{ label: _("discover.gamesTable.processingLevel.full"), value: "full" },
					{ label: _("discover.gamesTable.processingLevel.limited"), value: "limited" },
				],
				placeholder: _("discover.gamesTable.filterPlaceholder.requestedProcessingLevel"),
			},
		];
	},
};
